import React, { useEffect, useState } from "react";
import { Offcanvas, Nav, Navbar, Button, Dropdown } from "react-bootstrap";
import MenuIcon from "../assets/images/menu-icon.svg";
import TelegramIcon from "../assets/images/telegramIcon.svg";
import WhatsappIcon from "../assets/images/whatsappIconnew.png";
import UserIcon from "../assets/images/user-icon.svg";
import WalletIcon from "../assets/images/WalletIcon.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import { Link } from "react-router-dom";
import MobLeftbar from "./MobLeftbar";
import { AiOutlineClose } from "react-icons/ai";
import GamesSearchModal from "../views/components/GamesSearchModal";
import numberWithCommas from "../utils/numbersWithComma";
import BottomHead from "./BottomHead";
import museum from "../assets/images/museum.png";
import money from "../assets/images/save-money.png";
import ProfileIcon from "../assets/images/profile.png";
import BetIcon from "../assets/images/BetIcon.png";
import BonusImg from "../assets/images/bonus.png";
import refferal from "../assets/images/refferal.png";
import AcStatement from "../assets/images/AcStatement.png";
import LogoutIconImg from "../assets/images/logout.png";
import { getNotifications } from "../redux/app/actions";

const headerPages = [
  "home",
  "/sports/jetfair?section=inplay",
  "/atlas-lobby",
  "/live-dealer",
  "/allCasino",
  "/casino/evolution",
  "/casino/spribe/aviator",
];
const HeaderAfterLogin = () => {
  const { user, wallet } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShow1 = () => setShow1(!show1);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const htmlElement = document.documentElement;

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    if (show1) {
      htmlElement.style.overflow = "hidden";
    } else {
      htmlElement.style.overflow = "auto";
    }
  }, [show1]);

  const location = useLocation();
  const [activePage, setActivePage] = useState("");

  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  // console.log("balance", wallet);
  const [isBottomHead, setIsBottomHead] = useState(true);
  useEffect(() => {
    if (location.pathname.startsWith("/spmsports/")) {
      setIsBottomHead(false);
    } else {
      setIsBottomHead(true);
    }
  }, [isBottomHead]);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };
  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header afterlogin">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <Button
                  variant="primary menu-btn"
                  onClick={handleShow1}
                  className="d-block d-lg-none"
                >
                  <img src={MenuIcon} alt="User Menu Icon" width={25} />
                </Button>

                <div className="logo">
                  <a href="/sports">
                    <img src={appDetails?.LOGO_URL} alt="Logo" />
                    {/* <img src={logo} alt="Logo" /> */}
                  </a>
                </div>
                <div className="header-left ms-xl-4 d-none d-lg-block">
                  <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="d-none"
                  />
                  <Navbar.Collapse id="basic-navbar-nav" className="d-block">
                    <Nav className="me-auto">
                      <div
                        onClick={() => {
                          navigate("/sports/jetfair?section=inplay");
                        }}
                        className={
                          activePage === "/sports/jetfair?section=inplay"
                            ? "active-link"
                            : "nav-link"
                        }
                      >
                        Exchange
                      </div>

                      <div
                        onClick={() => {
                          navigate("/atlas-lobby");
                        }}
                        className={
                          activePage === "/atlas-lobby"
                            ? "active-link"
                            : "nav-link"
                        }
                      >
                        Sportsbook
                      </div>

                      <div
                        onClick={() => {
                          navigate("/allCasino");
                        }}
                        className={
                          activePage === "/allCasino"
                            ? "active-link"
                            : "nav-link"
                        }
                      >
                        Live Dealers
                      </div>

                      <div
                        onClick={() => {
                          navigate("/casino/spribe/aviator");
                        }}
                        className={
                          activePage === "/casino/spribe/aviator"
                            ? "active-link"
                            : "nav-link"
                        }
                      >
                        Aviator
                      </div>
                    </Nav>
                  </Navbar.Collapse>
                </div>

                <div className="headerRight ms-auto">
                  <ul>
                    <li className="d-none">
                      <a
                        className="wtp"
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "#"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsappIcon} alt="Whatsapp Icon" />
                      </a>
                    </li>
                    <li className="withdraw_deposit">
                      <a href="/gatewaylist">
                        <img src={museum} />
                        Deposit
                      </a>
                      <a href="/withdraw">
                        <img src={money} />
                        Withdraw
                      </a>
                    </li>
                    <li className="balance">
                      <div className="balance-amount" href="/cashier">
                        {/* <span> Bal: {wallet?.balance}</span>
                        <span>Cash: {numberWithCommas(wallet?.cash)}</span>
                        <span>Bonus: {numberWithCommas(wallet?.coins)}</span> */}
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            Bal: {wallet?.balance}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item href="javascript:voi(0)">
                              Balance: {wallet?.balance}
                            </Dropdown.Item>
                            <Dropdown.Item href="javascript:voi(0)">
                              Cash: {numberWithCommas(wallet?.cash)}
                            </Dropdown.Item>
                            <Dropdown.Item href="javascript:voi(0)">
                              Bonus: {numberWithCommas(wallet?.coins)}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </li>

                    <li>
                      <GamesSearchModal />
                    </li>
                    <li className="head-social">
                      <a
                        href={
                          appDetails?.TELEGRAM != ""
                            ? appDetails?.TELEGRAM
                            : "#"
                        }
                        target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                      >
                        <img src={TelegramIcon} alt="telegram" />
                      </a>
                    </li>

                    <li className="d-none">
                      <a
                        className="head-social"
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "#"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsappIcon} alt="whatsapp" />
                      </a>
                    </li>
                    {/* <div className="searchbar">
                    <AiOutlineSearch />
                  </div> */}
                  </ul>

                  <Button
                    variant="primary menu-btn"
                    onClick={handleShow}
                    className="d-none d-lg-block"
                  >
                    <img src={MenuIcon} alt="User Menu Icon" width={25} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Offcanvas
          className="user_section"
          show={show}
          onHide={handleClose}
          placement={"end"}
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={UserIcon} alt="User Icon" />
                </div>
                <div className="user-info">
                  <Link className="user_name">{user?.mstruserid}</Link>
                  <p>{user?.mobileno}</p>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container upperbalnace">
              <div className="row">
                <div className="col-6">
                  <div className="balance mb-4">
                    <img src={WalletIcon} alt="wallet" />
                    Balance
                  </div>
                </div>
                <div className="col-6">
                  <div className="balance-amount mb-4">
                    {" "}
                    INR {wallet?.balance}
                  </div>
                </div>

                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/withdraw");
                  }}
                >
                  <Button variant="" className="btn_withdraw w-100">
                    Withdraw
                  </Button>
                </div>
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/gatewaylist");
                  }}
                >
                  <Button variant="primary" className="btn_primary w-100">
                    Deposit
                  </Button>
                </div>
              </div>
            </div>

            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <img src={ProfileIcon} alt="my bet" />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={BetIcon} alt="my bet" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/bonus" className="img_size">
                  <img src={BonusImg} />
                  <span className="bonus-space">Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral" className="img_size">
                  <img src={refferal} />

                  <span className="bonus-space">Referral</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AcStatement} alt="account statement" />
                  <span>Account Statement</span>
                </a>
              </li>

              <li onClick={() => dispatch(logoutUser())}>
                <a href="/">
                  <img src={LogoutIconImg} />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>

            {/* <div className="theme-btn">
              <buton type="button" className="btn" onClick={toggleClass}>
                <img src={MoonLight} alt="moon" className="dark_theme" />
                <img src={SunLight} alt="sun" className="light_theme" />
              </buton>
            </div> */}
          </Offcanvas.Body>
        </Offcanvas>

        {show1 && <MobLeftbar className="d-block d-md-none" />}
      </header>

      {/* {isBottomHead && <BottomHead />} */}
      <BottomHead />
    </>
  );
};

export default HeaderAfterLogin;
